module.exports = __webpack_public_path__ + "img/vw.5b61ca9d.png";